export default "__VITE_ASSET__3UIh1P4c__"